(function() {
  angular.module('common')
  .factory('gridServices', function() {
    let service = {
      dateSort: _.curry(function(gridApiWrapper, fieldGetter, a, b, rowA, rowB) {
        var nulls = gridApiWrapper.gridApi.core.sortHandleNulls(a, b);
        if (nulls !== null) {
          return nulls;
        }
        return new moment(fieldGetter(rowA.entity)).unix() - new moment(fieldGetter(rowB.entity)).unix();
      })
    };
    return service;
  });
})();